import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import {
  clearCartItemsFromApi,
  clearCartLocally,
  clearCartItemsImmediately,
  removeCartItemFromApi,
} from '../cart/cartItemsSlice'
import { clearOffer } from './offersSlice'

/**
 * Clears offer state when the cart is emptied.
 * Promotion evaluation runs only from Send Order — not on cart mutations.
 */
export const offersListenerMiddleware = createListenerMiddleware()

offersListenerMiddleware.startListening({
  actionCreator: removeCartItemFromApi.fulfilled,
  effect: async (action, listenerApi) => {
    const payload = action.payload as { success?: boolean } | undefined
    if (payload && typeof payload === 'object' && 'success' in payload) {
      if (payload.success !== true) return
    }
    const state = listenerApi.getState() as {
      cartItems: { cartItems: unknown[] }
      csCart: { cartItems: unknown[] }
    }
    const cashierEmpty = (state.cartItems.cartItems?.length ?? 0) === 0
    const csEmpty = (state.csCart.cartItems?.length ?? 0) === 0
    if (cashierEmpty && csEmpty) {
      listenerApi.dispatch(clearOffer())
    }
  },
})

offersListenerMiddleware.startListening({
  matcher: isAnyOf(
    clearCartItemsFromApi.fulfilled,
    clearCartLocally,
    clearCartItemsImmediately,
  ),
  effect: async (_action, listenerApi) => {
    listenerApi.dispatch(clearOffer())
  },
})
